import { Breadcrumb, Layout, Spin } from "antd";
import React from "react";
import { NavLink } from "react-router-dom";
import { BuildAndReleaseSchema, User } from "../helpers/shared-interfaces";
import { isCompanyDetailsPage, isCustomerDetailsPage } from "../helpers/utilities";
import CompanyPageTitle from "./CompanyPageTitle";
import CustomerPageTitle from "./CustomerPageTitle";
import Navbar from "./Navbar";

export function BreadCrumbFactory(items: string[]): JSX.Element[] | [] {
  const itemsLength = items.length;
  const crumbs: JSX.Element[] = [];
  const newItemsArray: string[] = items.slice(0, itemsLength - 1);
  const nonRoutableSegments = new Set(["exceptions"]);
  let currentPath = "";
  newItemsArray.forEach((item, index) => {
    currentPath = index > 0 ? `${currentPath}/${item}` : `/${item}`;
    if (nonRoutableSegments.has(item)) {
      crumbs.push(
        <Breadcrumb.Item key={item}>
          <span style={{ textTransform: "capitalize" }}>{item}</span>
        </Breadcrumb.Item>,
      );
      return;
    }
    crumbs.push(
      <Breadcrumb.Item key={item}>
        <NavLink
          to={currentPath}
          style={{
            textTransform: "capitalize",
          }}
        >
          {item}
        </NavLink>
      </Breadcrumb.Item>,
    );
  });

  crumbs.push(
    <Breadcrumb.Item key="current-page">
      <span
        style={{
          textTransform: "capitalize",
        }}
      >
        {items[itemsLength - 1]}
      </span>
    </Breadcrumb.Item>,
  );

  return crumbs;
}

const { Content } = Layout;

interface State {
  isOpen: boolean;
  redirectToLogin: boolean;
  userName: string;
  loading: boolean;
  collapsed: boolean;
}

interface Props {
  releaseInfo: null | BuildAndReleaseSchema;
  children?: React.ReactNode;
  isLoading?: boolean;
  user: User;
  title: string;
  logout?: () => void;
}

interface Notification {
  id: string;
  message: string;
  status?: string;
}

export class Page extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isOpen: false,
      redirectToLogin: false,
      userName: "",
      loading: false,
      collapsed: false,
    };
  }

  componentDidMount(): void {
    document.title = "Phoenix - " + this.props.title;
  }

  getPageTitle = (): JSX.Element | string => {
    if (isCustomerDetailsPage()) return <CustomerPageTitle />;
    if (isCompanyDetailsPage()) return <CompanyPageTitle />;
    return this.props.title;
  };

  render(): JSX.Element | null {
    const { children, isLoading, user, releaseInfo } = this.props;

    let UI = children;

    if (isLoading)
      UI = (
        <div
          style={{
            textAlign: "center",
          }}
        >
          <Spin size="large" />
        </div>
      );

    const crumbs = BreadCrumbFactory(
      window.location.pathname
        .split("/")
        .filter((item: string): boolean => item !== ""),
    );

    return (
      <Layout
        style={{
          height: "100%",
        }}
      >
        <Layout
          style={{
            backgroundColor: "white",
          }}
        >
          <Navbar
            username={user.name}
            department={user.department?.name}
            role={user.role?.name}
            logout={this.props.logout}
            userNotifications={user.userNotifications}
            releaseInfo={releaseInfo}
          />
          <Content style={{ overflow: "scroll", overflowX: "hidden" }}>
            <div className="app-content-container">
              <Breadcrumb>{crumbs}</Breadcrumb>

              <div
                style={{
                marginBottom:
                  isCustomerDetailsPage() || isCompanyDetailsPage() ? 0 : "30px",
              }}
            >
                <h1
                  style={{
                    fontWeight: "bold",
                    fontSize: "25px",
                  }}
                >
                  {this.getPageTitle()}
                </h1>
              </div>
              {UI}
            </div>
          </Content>
        </Layout>
      </Layout>
    );
  }
}

export default Page;
